// extracted by mini-css-extract-plugin
var _1 = "nav_active";
export { _1 as "active" }
